import React from 'react';
import { horizontalPadding, StyledItemText, StyledList, StyledSelectItem, StyledSelectListItem } from './SelectListItem.styled';
export function SelectListItem(_ref) {
  var children = _ref.children,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    selected = _ref.selected;
  var onKeyPress = function onKeyPress(e, item) {
    if (e.key === 'Enter' || e.key === ' ') {
      onClickHandler(e, item);
    }
  };
  var onClickHandler = function onClickHandler(e, item) {
    item.disabled ? e.stopPropagation() : item.onClick();
  };
  var outerItem = {
    onClick: onClick,
    disabled: disabled
  };
  return /*#__PURE__*/React.createElement(StyledSelectListItem, {
    role: "menuitem",
    onKeyUp: function onKeyUp(e) {
      return onKeyPress(e, outerItem);
    },
    tabIndex: disabled ? -1 : 0,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(StyledSelectItem, {
    onClick: function onClick(e) {
      return onClickHandler(e, outerItem);
    },
    disabled: disabled || false,
    selected: selected
  }, /*#__PURE__*/React.createElement(StyledItemText, null, children)), !!items.length && /*#__PURE__*/React.createElement(StyledList, null, items.map(function (innerItem, i) {
    return /*#__PURE__*/React.createElement(StyledSelectListItem, {
      role: "menuitem",
      key: i,
      onKeyUp: function onKeyUp(e) {
        return onKeyPress(e, innerItem);
      },
      tabIndex: innerItem.disabled ? -1 : 0,
      disabled: innerItem.disabled
    }, /*#__PURE__*/React.createElement(StyledSelectItem, {
      onClick: function onClick(e) {
        return onClickHandler(e, innerItem);
      },
      disabled: innerItem.disabled || false,
      selected: innerItem.selected
    }, /*#__PURE__*/React.createElement(StyledItemText, {
      style: {
        marginLeft: horizontalPadding
      }
    }, innerItem.children)));
  })));
}